import { render, staticRenderFns } from "./DashboardPerformanceCustomer.vue?vue&type=template&id=385c4c7d&"
import script from "./DashboardPerformanceCustomer.vue?vue&type=script&lang=js&"
export * from "./DashboardPerformanceCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPerformanceCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports